import ProductProvider from 'providers/ProductProvider';
import React from 'react';
import TopNavLayoutNavbarTop from 'components/navbar/top/TopNavLayoutNavbarTop';
import { Outlet } from 'react-router-dom';

const TopNavLayout = () => {
  return (
    <div className="container">
      <ProductProvider>
        <div className="content">
          <TopNavLayoutNavbarTop />
          <Outlet />
        </div>
      </ProductProvider>
    </div>
  );
};

export default TopNavLayout;
